import Stack from "@mui/material/Stack";

import { useEnableUcDashboard } from "@/features/billing/useEnableUcDashboard";
import { CostSummaryCard } from "@/pages/billing/v2/tabs/overview/CostSummaryCard";
import { FeatureUsageBreakdown } from "@/pages/billing/v2/tabs/overview/FeatureUsageBreakdown";
import { UniqueContactsCard } from "@/pages/billing/v2/tabs/overview/UniqueContactsCard";

export const OverviewTab: React.FC = function OverviewTab() {
  const enableUcDashboard = useEnableUcDashboard();

  return (
    <Stack gap="32px">
      <CostSummaryCard />
      {enableUcDashboard ? <UniqueContactsCard /> : null}
      <FeatureUsageBreakdown />
    </Stack>
  );
};
